import { useQuery } from "react-query";
import { getClaims } from "../services/user/getClaims";

export const useGetClaims = () => useQuery('claims', ()=> getClaims());